import { useLocation, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useMe } from '@/shared/api/auth'
import { hasAnyRole, hasRole, ROLE_CODE_LIST, ROLE_GROUPS } from '@/shared/const'
import { useAuthStore } from '@/shared/store/auth-store'

export const useAuthRedirect = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { data: currentUser } = useMe()
  const { isAuthenticated } = useAuthStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
    }))
  )

  const isLoginRoute = location.pathname.startsWith('/login')
  const isAuthRoute = location.pathname.startsWith('/auth')
  const isCanteenDashboardRoute = location.pathname.startsWith('/canteen-dashboard')
  const isDashboardViewer = hasRole(currentUser?.roles, ROLE_CODE_LIST.DASHBOARD_VIEWER)
  const isDashboardOnlyUser = hasAnyRole(currentUser?.roles, ROLE_GROUPS.DASHBOARD_ONLY)

  useEffect(() => {
    if (!isAuthenticated && !isLoginRoute && !isAuthRoute) {
      navigate({
        to: '/login',
        replace: true,
      })
      return
    }

    if (isAuthenticated && (isDashboardViewer || isDashboardOnlyUser) && !isCanteenDashboardRoute) {
      navigate({
        to: '/canteen-dashboard',
        replace: true,
      })
      return
    }

    if (
      isAuthenticated &&
      (location.pathname.startsWith('/login') || location.pathname.startsWith('/auth'))
    ) {
      navigate({
        to: '/',
        replace: true,
      })
    }
  }, [
    isAuthenticated,
    navigate,
    location,
    isLoginRoute,
    isAuthRoute,
    isDashboardViewer,
    isDashboardOnlyUser,
    isCanteenDashboardRoute,
  ])
}
